import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { dismiss, sendPersistentAlert } from '../actions';
import { getCurrentAlert } from '../selectors';
import { Alertbar } from '../components/Alertbar';

const AlertbarContainer = connect(
  createStructuredSelector({
    alert: getCurrentAlert,
  }),
  {
    onClose: dismiss,
    onSendPersistentAlert: sendPersistentAlert,
  },
)(Alertbar);
export { AlertbarContainer };
// eslint-disable-next-line import/no-default-export
export default AlertbarContainer;
